import { useEffect, useState } from 'react'
import { usePrinterHooks } from '@justomx/atlas-components'

export const usePrinterReady = () => {
  const { isConfigured } = usePrinterHooks()
  const [printerReady, setPrinterReady] = useState(false)

  useEffect(() => {
    isConfigured()
      .then((configured) => {
        setPrinterReady(configured)
      })
      .catch((error) => {
        console.info('Error validating printer status', error)
      })
  }, [])

  return printerReady
}
